import { ReportAttributes, ReportRelationships } from 'dashboard/models/report';
import { ApiModel, ApiResource } from 'lib/interfaces/api';

export enum BusinessWebsiteMatchStatus {
  Full = 'full',
  Partial = 'partial',
  None = 'none',
}

export interface Website {
  url: string;
}

export interface ReportBusinessWebsiteAttributes extends ReportAttributes {
  query: {
    'business-name': string;
    website: string;
  };
  result: {
    website: Website | null;
    'associated-websites': Website[];
  };
  'business-name'?: string | null;
  'match-status-website'?: BusinessWebsiteMatchStatus;
}

export type ReportBusinessWebsite = ApiResource<
  ReportBusinessWebsiteAttributes,
  ReportRelationships,
  ApiModel.ReportBusinessWebsite
>;
